import './pages.css';
import { Link } from 'react-router-dom';

const Fixed = () => {
    const products = [
        { name: 'BruxZir®', path: '/products/fixed/bruxzir', image: '/images/fixed/bruxzir.webp' },
        { name: 'Full Cast', path: '/products/fixed/fullcast', image: '/images/fixed/fullcast.webp' },
        { name: 'Full Contour Zirconia', path: '/products/fixed/zirconia', image: '/images/fixed/zirconia.webp' },
        { name: 'PFM', path: '/products/fixed/pfm', image: '/images/fixed/pfm.webp' },
        { name: 'IPS e.max', path: '/products/fixed/emax', image: '/images/fixed/ips.webp' },
        { name: 'PMMA Provisional', path: '/products/fixed/pmma', image: '/images/fixed/pmma.webp' },
        { name: 'Zirlux®', path: '/products/fixed/zirlux', image: '/images/fixed/zirlux.webp' }
    ];

    return (
        <div className="page fixed">
            {/* Hero Section */}
            <section className="products-hero-section">
                <div className="products-hero-content">
                    <h1>Fixed Prosthetics</h1>
                    <p className="products-tagline">Permanent dental solutions for lasting smiles</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="products-content-section">
                <div className="content-container">
                    {/* Intro Card */}
                    <div className="products-intro-card">
                        <p>
                            AbELab offers fixed restorations that provide both exceptional quality and unmatched esthetics.
                            Our solutions include industry standards, such as PFMs, as well as high-quality full-contour zirconia.
                            Every fixed restoration we fabricate utilizes digital dentistry in some way, whether that be scanning,
                            designing, or milling.
                        </p>
                    </div>

                    {/* Products Grid */}
                    <div className="products-grid-enhanced">
                        {products.map((product, index) => (
                            <Link to={product.path} key={index} className="product-card-enhanced">
                                <div className="product-image-wrapper">
                                    <img src={product.image} alt={product.name} />
                                </div>
                                <div className="product-info">
                                    <h3>{product.name}</h3>
                                    <span className="learn-more">Learn More →</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Fixed;
